import script from "./ColumnHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnHeader.vue?vue&type=script&setup=true&lang=js"

import "./ColumnHeader.vue?vue&type=style&index=0&id=6b12ad1c&lang=scss"

const __exports__ = script;

export default __exports__